import React from 'react';
import Image from 'next/image';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import { Typography } from '../typography';
import { Ellipsis } from 'lucide-react';
import { AdCampaign } from '@/interfaces';
import { Roboto } from 'next/font/google';

export const roboto = Roboto({
	subsets: ['latin'],
	weight: ['400', '500', '700'],
	style: ['normal', 'italic'],
	display: 'swap',
	preload: true,
	variable: '--font-roboto',
});

export const FacebookPost: React.FC<AdCampaign> = ({ copy, image_url }) => {
	return (
		<div
			className={`border border-grey-100 bg-white rounded-2xl w-full ${roboto.className}`}
		>
			<div className="flex flex-col items-start pt-5 px-5 pb-[18px] space-y-2">
				<div className="flex items-center justify-between w-full">
					<div className="flex items-center gap-x-2 ">
						<Icon src={Icons.avatarFacebookSponsored} className="!size-11" />
						<div className="flex flex-col gap-y-1">
							<Typography
								type="regular-16"
								className={`!text-[#395996] ${roboto.className}`}
							>
								Claim Magic
							</Typography>
							<div className="flex items-center gap-[2px]">
								<Typography
									type="regular-13"
									className="font-roboto !text-[#606770]"
								>
									7h
								</Typography>
								<div className="w-[18px] h-[13px]">
									<Icon src={Icons.worldFacebook} className="w-full h-full" />
								</div>
							</div>
						</div>
					</div>
					<div>
						<Ellipsis className="text-[#606770]" size={20} />
					</div>
				</div>
				<div className="">
					<p
						className="!text-[15px] !font-roboto !leading-5 tracking-[0.5%] text-left !text-[#1D2129]"
						dangerouslySetInnerHTML={{ __html: copy }}
					/>
				</div>
			</div>
			<div>
				<Image
					src={image_url || Icons.imageEmptyState}
					alt="image"
					width={558}
					height={288}
					className="w-full max-h-[288px]"
					quality={75}
				/>
			</div>
			<div className="py-3 px-4">
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-1">
						<Icon src={Icons.facebookLikeGroup} className="!size-[45px]" />
						<Typography type="regular-16" className="!text-[#606770]">
							541
						</Typography>
					</div>
					<div className="flex items-center gap-3">
						<Typography type="regular-16" className="!text-[#606770]">
							26 Comments
						</Typography>
						<Typography type="regular-16" className="!text-[#606770]">
							87 Shares
						</Typography>
					</div>
				</div>
				<hr className="mt-3 pb-4" />
				<div className="flex items-center justify-between pl-7 pr-3 pb-2">
					<div className="flex items-center gap-[7px]">
						<Icon src={Icons.facebookLike} className="!size-5" />
						<Typography type="regular-16" className="!text-[#606770]">
							Like
						</Typography>
					</div>
					<div className="flex items-center gap-2">
						<Icon src={Icons.facebookComment} className="!size-5" />
						<Typography type="regular-16" className="!text-[#606770]">
							Comment
						</Typography>
					</div>
					<div className="flex items-center gap-2">
						<Icon src={Icons.facebookShare} className="!size-5" />
						<Typography type="regular-16" className="!text-[#606770]">
							Share
						</Typography>
					</div>
					<div className="flex items-center gap-1">
						<Icon
							src={Icons.avatarFacebookSponsored}
							className="!size-[18px]"
						/>
						<Icon src={Icons.caretDown} className="!w-[9px]" />
					</div>
				</div>
			</div>
		</div>
	);
};
